<bfx-autoComplete
  #autocompleteControl
  appendTo="body"
  nativeDesktopDropdown="goodFromUntil"
  target="goodFromUntil"
  [(ngModel)]="data.input.value"
  [suggestions]="data.marketSuggestions"
  [ngClass]="{
    'interface-control__good-from-until__input': true,
    'interface-control__good-from-until__input--locked': data.locked,
    'interface-control__good-from-until__input--invalid': data.errorMsg != null
  }"
  [minLength]="1"
  [placeholder]="data.input.placeholder"
  [dropdown]="true"
  [disabled]="data.locked"
  [autoHighlight]="true"
  [allowEmptySelection]="true"
  [useAlternateBlur]="false"
  [alternateConfig]="config.goodFromUntilAutocompleteConfig"
  [emptyIsInactive]="true"
  [fieldEndIcon]="[
    'bfx-ignore-target fa fa-fw icon_ion_chevron_down bfx-field-select-button-toggle',
  ]"
  (fieldIconClick)="onFieldIconClick($event, autocompleteControl, calendarControl)"
  [skipSorting]="true"
  [inputLabelText]="data.input.label"
  (completeMethod)="marketSuggestion($event)"
  (onSelect)="selectedMarketLabelHandler($event)"
  (onFocus)="onInputFocus($event)"
  (onBlur)="onInputBlur($event)"
  (onClear)="onInputClear()"
  [bfxTooltip]="data.errorMsg"
  tooltipPosition="top"
  tooltipStyleClass="interface-control__good-from-until__tooltip"
  [tooltipDisabled]="inputFocused"
  [size]="'sm'"
>
</bfx-autoComplete>
<bfx-calendar
  #calendarControl
  appendTo="body"
  panelStyleClass="bfx-calendar__dropdown__container"
  dateFormat="DD-MMM-YYYY"
  [showIcon]="true"
  [showActionsBar]="false"
  [adjustForTimeZone]="true"
  nativeDesktopCalendar="good-from-until"
  [placeholder]="'DD-M-YY'"
  [(ngModel)]="data.calendarValue"
  (dateValueInput)="calendarAssignToModel($event)"
  [selectIsSave]="true"
  [disabled]="data.calendarLocked || data.locked"
  [autoCompletePosition]="autocompleteControl"
  [alignToAutocompleteInput]="false"
  [showOnFocus]="true"
  [hideOnDateTimeSelect]="true"
  [parseInput]="false"
  [keepInvalid]="true"
  (onBlur)="onCalendarBlur($event)"
  (onFocus)="onCalendarFocus($event)"
  [ngClass]="{
    'interface-control__bfx-calendar__time__input-state--hidden': !this.data.calendarVisible
  }"
>
</bfx-calendar>
<bfx-time-input
  #inputTimeField
  [(ngModel)]="data.timeValue"
  (ngModelChange)="timeAssignToModel($event)"
  [enableInputTimezone]="true"
  [disabled]="data.inputTimeFieldLocked || data.locked"
  [ngClass]="{
    'interface-control__bfx-calendar__time__input': true,
    'interface-control__bfx-calendar__time__input-state--valid': data.state === 0,
    'interface-control__bfx-calendar__time__input-state--invalid': data.state === 1,
    'interface-control__bfx-calendar__time__input-state--active': data.state === 2,
    'interface-control__bfx-calendar__time__input-state--hidden': !this.data.inputTimeFieldVisible
  }"
  (focus)="onTimeInputFocus($event)"
  (blur)="onTimeInputBlur($event)"
></bfx-time-input>
